import React from 'react';
import { Users, Smile, CheckCircle, Headphones, Clock, RotateCcw, Zap, BarChart3 } from 'lucide-react';

const ChatGPTStats = () => {
 const stats = [
 { number: '50K+', label: 'Active Users', icon: <Users /> },
 { number: '98.7%', label: 'Satisfaction Rate', icon: <Smile /> },
 { number: '99.9%', label: 'Success Rate', icon: <CheckCircle /> },
 { number: '24/7', label: 'Support', icon: <Headphones /> },
 { number: '18+', label: 'Months Service', icon: <Clock /> },
 { number: '94%', label: 'Renewal Rate', icon: <RotateCcw /> }
 ];

 const features = [
 {
 title: 'Service Quality Guarantees',
 icon: <CheckCircle />,
 items: [
 'Professionally managed ChatGPT Plus accounts',
 'Regular performance monitoring and optimization',
 'Immediate technical support for any issues',
 '30-day money-back guarantee for peace of mind'
 ]
 },
 {
 title: 'Built for Professional Use',
 icon: <BarChart3 />,
 items: [
 'Enterprise-grade account management system',
 'Redundant systems for maximum reliability',
 'Continuous service improvement based on user feedback',
 'Long-term sustainability and growth planning'
 ]
 },
 {
 title: 'User Success Metrics',
 icon: <Zap />,
 items: [
 'Average <5 minutes setup time for new users',
 '94% user renewal rate',
 '99.9% service uptime maintained',
 '2 hours average support response time'
 ]
 }
 ];

 return (
 <section className="py-20 bg-cream-100">
 <div className="container mx-auto px-4">
 <div className="text-center mb-16">
 <h2 className="text-4xl md:text-5xl font-bold text-ink-900 mb-4">
 Growing Community of Satisfied Users
 </h2>
 <p className="text-xl text-ink-600 max-w-2xl mx-auto">
 Real users, real ChatGPT Plus results
 </p>
 </div>

 <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 max-w-6xl mx-auto mb-16">
 {stats.map((stat, index) => (
 <div key={index} className="text-center p-6 bg-white border border-ink-200 rounded-lg hover:border-black transition-colors duration-200">
 <div className="text-black mb-2 flex justify-center">{stat.icon}</div>
 <div className="text-3xl md:text-4xl font-bold text-ink-900 mb-2">{stat.number}</div>
 <div className="text-sm text-ink-600">{stat.label}</div>
 </div>
 ))}
 </div>

 <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
 {features.map((feature, index) => (
 <div key={index} className="bg-white border border-ink-200 rounded-lg p-8">
 <div className="flex items-center mb-6">
 <div className="text-2xl text-black mr-3">{feature.icon}</div>
 <h3 className="text-xl font-semibold text-ink-900">{feature.title}</h3>
 </div>
 <ul className="space-y-3">
 {feature.items.map((item, idx) => (
 <li key={idx} className="flex items-start">
 <span className="text-black mr-2 mt-1 flex-shrink-0">•</span>
 <span className="text-ink-700 leading-relaxed">{item}</span>
 </li>
 ))}
 </ul>
 </div>
 ))}
 </div>

 <div className="text-center mt-16 p-8 bg-black text-white rounded-lg max-w-4xl mx-auto">
 <h3 className="text-2xl font-semibold mb-6">
 Our Service Performance
 </h3>
 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
 <div>
 <div className="text-2xl font-bold mb-2">50,000+</div>
 <p className="text-sm opacity-90">Active ChatGPT Plus users</p>
 </div>
 <div>
 <div className="text-2xl font-bold mb-2">98.7%</div>
 <p className="text-sm opacity-90">User satisfaction rate</p>
 </div>
 <div>
 <div className="text-2xl font-bold mb-2">99.9%</div>
 <p className="text-sm opacity-90">Successful activation rate</p>
 </div>
 <div>
 <div className="text-2xl font-bold mb-2">24/7</div>
 <p className="text-sm opacity-90">Dedicated support available</p>
 </div>
 </div>
 </div>
 </div>
 </section>
 );
};

export default ChatGPTStats;